<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>Our Blessed Rebel Queen</h1>
<h1 class="bk1">Essays on Carrie Fisher and Princess Leia</h1>
<p class="bkau">Edited by Linda Mizejewski and Tanya D. Zuk</p>
<p class="bkpub"><img alt="" height="75" src="images/wsu-mizejewski-wsulogo.jpeg" width="75"/></p>
<p class="bkpub1">Wayne State University Press</p>
<p class="bkpub1">Detroit</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-midejewski-0004.vue?7210bc0e